<script setup lang="ts">
import type { Swiper } from 'swiper/types'

const props = defineProps<{
  swiper: Swiper
  index: number
}>()

const activeIndex = ref<number>(0)

props.swiper.on('activeIndexChange', instance => activeIndex.value = instance.activeIndex)

const active = computed(() => activeIndex.value === props.index)
</script>

<template>
  <div
    class="size-6 group flex items-center justify-center cursor-pointer"
    @click="props.swiper.slideTo(props.index)"
  >
    <div
      class="size-3 rounded-full" :class="{
        'bg-primary-700 group-hover:bg-primary-400 dark:bg-primary-100 dark:group-hover:bg-primary-400': active,
        'bg-primary-200 group-hover:bg-primary-300 dark:bg-neutral-800 dark:group-hover:bg-primary-700': !active,
      }"
    />
  </div>
</template>
